import React from "react";
import { LinearProgress, linearProgressClasses, LinearProgressProps, SxProps, Theme } from "@mui/material";

// export type colorGradientObject =
//   | {
//       1: string;
//       2: string;
//       3: string;
//     }
//   | {
//       1: string;
//       2: string;
//       3: string;
//       4: string;
//       5: string;
//     };

//------ extra types based on checks ----------

//can have either singular bar color or gradient, not both
// type ColorProps =
//   | {
//       barColor?: string;
//       barMultiColor?: never;
//     }
//   | {
//       barColor?: never;
//       barMultiColor?: colorGradientObject;
//     };

//should have BOTH maxValue and minValue if one is filled
type RangeProps =
  | {
      maxValue?: never;
      minValue?: never;
    }
  | {
      maxValue: number;
      minValue: number;
    };

type WcLinearGaugeBaseProps = Omit<LinearProgressProps, "color"> & {
  height?: number;
  sx?: SxProps<Theme>;
};

export type WcLinearGaugeProps = WcLinearGaugeBaseProps & RangeProps;
//-------------------------
export const WcLinearGauge = ({
  value,
  variant = "determinate",
  height = 15,
  sx,
  minValue = 0,
  maxValue = 100,
  ...rest
}: WcLinearGaugeProps) => {
  const barMultiColor = {
    1: "#d82e18",
    2: "#db7c2e",
    3: "#CCA400",
    4: "#8FB302",
    5: "#3D9901",
  };
  // Function to normalise the values (MIN / MAX could be integrated)
  const normalise = (incomingVal) => ((incomingVal - minValue) * 100) / (maxValue - minValue);

  const nomalisedValue = normalise(value);

  const getGradient = () => {
    if (!barMultiColor) return "#3D9901";
    const colors = Object.values(barMultiColor);
    const numColors = colors.length;

    const segmentWidth = 100 / (numColors - 1);
    const activeColorIndex = Math.ceil(nomalisedValue / segmentWidth);

    const gradientColors = colors.slice(0, activeColorIndex + 1);

    const gradientString = gradientColors
      .map((color, index) => {
        const position = gradientColors.length > 1 ? (index / (gradientColors.length - 1)) * 100 : 0;
        return `${color} ${position}%`;
      })
      .join(", ");

    return `linear-gradient(90deg, ${gradientString})`;
  };

  return (
    <LinearProgress
      sx={[
        {
          //width should be set to 100%, otherwise this bar will disappear on flex styled stuff
          width: "100%",
          backgroundColor: "lightgray",
          height: height,
          borderRadius: 5,
          [`& .${linearProgressClasses.bar}`]: {
            backgroundImage: getGradient(),
            //for when the commented out code is used
            // backgroundColor: barColor ? barColor : undefined,
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      value={minValue || maxValue ? normalise(value) : value}
      variant={variant}
      {...rest}
    />
  );
};

export default WcLinearGauge;
